import { render, staticRenderFns } from "./RichTextTextStyle.vue?vue&type=template&id=73bb5b3d&"
import script from "./RichTextTextStyle.vue?vue&type=script&lang=js&"
export * from "./RichTextTextStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports